var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1877F2",
    d: "M512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 127.9 93.8 233.8 216 253v-178.8h-65V256h65v-58.8c0-64.2 38.2-99.7 96.8-99.7 28.1 0 57.4 5 57.4 5v63.1h-32.4c-31.8 0-41.7 19.8-41.7 40.1V256h71.1l-11.4 74.2h-59.7V509c122.2-19.2 216-125.1 216-253z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M351.8 330.2l11.4-74.2h-71.1V207.1c0-20.3 10-40.1 41.7-40.1h32.4v-63.1s-29.3-5-57.4-5c-58.6 0-96.8 35.5-96.8 99.7V256h-65v74.2h65V509c12.2 1.9 24.7 3 37.3 3s25.1-1.1 37.3-3V330.2h59.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/facebookLogo.02d2480696b34d2c0b7a92ff2c04af4a.svg";
export { ForwardRef as ReactComponent };